import queryString from 'qs';

const getProductHighlightListRequest = (queryParams) => {
  const queries = { limit: queryParams?.limit, page: queryParams?.page };

  if (queryParams?.search) queries.search = queryParams?.search;
  if (queryParams?.brand) queries['brands.name'] = queryParams?.brand?.label;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getProductHighlightListRequest;
